import { render, staticRenderFns } from "./notifications.card.vue?vue&type=template&id=de09e3d6&"
import script from "./notifications.card.vue?vue&type=script&lang=js&"
export * from "./notifications.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports